export default [
    {
        path: 'relatorio-cuidado-pessoa-idosa',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-idosa' */
            '@/views/atencao-basica/relatorio-cuidado-pessoa-idosa/Index'
        ),
        redirect: 'relatorio-cuidado-pessoa-idosa/index',
        children: [
            {
                name: 'atencao-basica-relatorio-cuidado-pessoa-idosa-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-cuidado-pessoa-idosa' */
                    '@/views/atencao-basica/relatorio-cuidado-pessoa-idosa/List.vue'
                ),
            },
        ],
    },
]